module.exports = __webpack_public_path__ + "img/face_vomiting.a094f4e0.gif";